import axios from "axios";

export default {
    logout() {
        return axios.post("/api/logout");
    }
};
